import { useEffect, useRef } from 'react';

export function useVisibility<T extends HTMLElement>(
    onVisible: () => void,
    options: IntersectionObserverInit = { threshold: 0.1 }
) {
    const elementRef = useRef<T | null>(null);
    const hasBeenVisible = useRef(false);

    useEffect(() => {
        const target = elementRef.current;
        if (!target || hasBeenVisible.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                hasBeenVisible.current = true;
                onVisible();
                observer.disconnect(); // stop after first trigger
            }
        }, options);

        observer.observe(target);

        return () => observer.disconnect();
    }, [onVisible, options]);

    return elementRef;
}
